module.exports = __webpack_public_path__ + "img/9788972574125.642e626f.jpg";